import { DataTable } from "primereact/datatable";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { JVInput } from "../../../shared/JVInput";
import { JVCheckbox } from "../../../shared/JVCheckbox";
import { Toast } from "primereact/toast";
import { Fetch } from "../../../shared/Fetch";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { ILogin } from "../../../models/Login";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { IBranchMastDropdown, ICompanyMastDropdown } from "../../../models/IDropdown";

interface MonsterPasswordDetails {
    id?: number,
    clientTypeName?: string,
    clientId?: string,
    clientSecret?: string,
    cat_ID?: string,
    status?: boolean,
}

interface MonsterPasswordDetailList {
    id: number,
    clientTypeName?: string,
    clientId?: string,
    clientSecret?: string,
    status?: boolean,
    cat_ID?: string,
    created_By?: string,
    created_On?: Date,
    updated_By?: string,
    updated_On?: Date,
}

interface MonsterPasswordMappingList {
    id?: number,
    company_Name?: string,
    branchName?: string,
    created_On?: Date,
}

const schema = yup.object({
    clientTypeName: yup.string().nullable(),
    clientId: yup.string().nullable(),
    clientSecret: yup.string().nullable(),
    cat_ID: yup.string().nullable(),
    status: yup.boolean().nullable(),
});

export const AdminSetting = () => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<MonsterPasswordDetailList>, loading: boolean });
    const [mappingList, setMappingList] = useState({ tableData: [], loading: false } as { tableData: Array<MonsterPasswordMappingList>, loading: boolean });
    const [mosterPasswords, setMosterPasswords] = useState({ open: false, singleData: {} } as { open: boolean, singleData: MonsterPasswordDetails });
    const [loading, setLoading] = useState(false);
    const [mosterPasswordsMapping, setMosterPasswordsMapping] = useState({ open: false, singleData: {} } as { open: boolean, singleData: MonsterPasswordDetailList });
    const [selectedGroup, setSelectedGroup] = useState<MonsterPasswordDetailList | null>(null);
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [selectedCompany, setSelectedCompany] = useState<number>(0);
    const [selectedBranch, setSelectedBranch] = useState<number[]>([]);
    const dt = useRef<any>(null);
    const toast = useRef<any>(null);

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
    loginObj.roles.forEach((role) => {
        _roles.push(role.role_ID);
    });

    const { control, handleSubmit, unregister, formState: { errors }, reset, setValue, watch } = useForm<MonsterPasswordDetails>({
        resolver: yupResolver(schema),
        defaultValues: { clientTypeName: "", status: true },
        shouldFocusError: false
    });

    const leftToolbarTemplate = () => {
        return <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={() => setMosterPasswords({ open: true, singleData: {} })} />;
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Monster_Setting/getMonsterSecretKeys", "GET", null, null, toast);
        if (response) {
            const data: MonsterPasswordDetailList[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const loadTableData2 = async (id: number) => {
        setMappingList({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Monster_Setting/getMonsterSecretKeyMapping", "GET", null, `id=${id}`, toast);
        if (response) {
            const data: MonsterPasswordMappingList[] = await response.json();
            setMappingList({ tableData: data, loading: false });
        } else setMappingList({ tableData: tableData.tableData, loading: false });
    }

    const onSubmit = async (data: MonsterPasswordDetails) => {
        if (data?.id === 0) {
            delete data?.id;
        };

        const method = (data?.id !== undefined && data?.id !== null && data?.id > 0) ? "PUT" : "POST";
        const url = (data?.id !== undefined && data?.id !== null && data?.id > 0) ? "updateMonsterSecretKeys" : "addMonsterSecretKeys";

        const response = await Fetch("Monster_Setting/" + url, method, data, null, toast);
        if (response) {
            setMosterPasswords({ open: false, singleData: {} });
            loadTableData();
            reset({
                id: 0,
                clientTypeName: "",
                clientId: "",
                clientSecret: "",
                status: true,
            });
        }
    }

    const handleDelete = async (data: MonsterPasswordMappingList) => {
        const response = await Fetch("Monster_Setting/removeMonsterSecretKeysMapping", "DELETE", null, `id=${data.id}`, toast);
        if (response) {
            loadTableData2(mosterPasswordsMapping.singleData?.id || 0);
        }
    }

    const handleSubmit2 = async () => {
        if (selectedBranch.length === 0) {
            toast.current.show({ severity: 'error', detail: "Select atleast 1 branch", life: 3000 });
        } else {
            const response = await Fetch("Monster_Setting/addMonsterSecretKeysMapping", "POST", {
                ID: mosterPasswordsMapping.singleData.id,
                Branchs: selectedBranch
            }, null, toast);
            if (response) {
                setSelectedCompany(0);
                setSelectedBranch([]);
                loadTableData2(mosterPasswordsMapping.singleData?.id || 0);
            }
        }
    }

    const actionBodyTemplate = (rowData: MonsterPasswordDetailList) => {

        return (
            <div className="actions">
                <Button icon="pi pi-pencil text-primary" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => {
                    setMosterPasswords({
                        open: true, singleData: {
                            id: rowData.id,
                            clientTypeName: rowData.clientTypeName,
                            clientId: rowData.clientId,
                            clientSecret: rowData.clientSecret,
                            status: rowData.status,
                            cat_ID: rowData?.cat_ID || ""
                        }
                    });
                    reset({
                        id: rowData.id,
                        clientTypeName: rowData.clientTypeName,
                        clientId: rowData.clientId,
                        clientSecret: rowData.clientSecret,
                        status: rowData.status,
                        cat_ID: rowData?.cat_ID || ""
                    });
                }} />
                <Button className="pi pi-external-link text-primary bg-white border-none" onClick={() => {
                    setMosterPasswordsMapping({ open: true, singleData: rowData });
                    loadTableData2(rowData.id);
                }}></Button>
            </div>
        );
    };

    const DataFormat = loginObj.date_Format;

    const loadCompanies = async () => {
        const res = await Fetch("Dropdown/company", "GET", null, null, null);
        if (res) {
            const data: Array<ICompanyMastDropdown> = await res.json();
            setCompanies(data || []);
        }
    };

    const loadBranches = async (company: number) => {
        let queryParam = company ? `company_id=${company}` : null;
        let endPoint = loginObj.id === 1346 ? "allBranches" : "reqBranchList";

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    }

    useEffect(() => {
        loadTableData();
        loadCompanies();
    }, []);

    useEffect(() => {
        if (selectedCompany !== undefined && selectedCompany !== null && selectedCompany > 0) {
            loadBranches(selectedCompany);
        }
    }, [selectedCompany]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData} lazy dataKey="id"
                header={<p>Header</p>}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="clientTypeName" header="Name" />
                <Column field="clientId" header="Client ID" />
                <Column field="clientSecret" header="Client Secret Key" />
                <Column field="cat_ID" header="Cat Secret Key" style={{ maxWidth: "7rem", overflow: "hidden" }} body={(rowData: any) => <Button tooltip={rowData?.cat_ID || "No Cat ID"} className="p-button-text" style={{ overflow: "hidden", color: "blue", maxWidth: "7rem" }}>{rowData.cat_ID}</Button>} />
                <Column field="status" header="Status" body={(rowData: any) => <p>{rowData.status === true ? "Active" : "InActive"}</p>} />
                <Column field="created_By" header="Created By" />
                <Column field="created_On" style={{ minWidth: "100px" }} header="Created On" body={(rowData: any) => safeFormatDate(rowData.created_On, "dd/MM/yyyy", DataFormat)} />
                <Column body={actionBodyTemplate} />
            </DataTable>
            <Dialog visible={mosterPasswords.open} header="Fix Email Errors" modal style={{ width: "50vw" }} onHide={() => setMosterPasswords({ open: false, singleData: {} })} >
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
                    <JVInput required column={2} label="Name" control={control} name="clientTypeName" error={errors.clientTypeName?.message} />
                    <JVInput required column={2} label="Client ID" control={control} name="clientId" error={errors.clientId?.message} />
                    <JVInput required column={2} label="Client Secret Key" control={control} name="clientSecret" error={errors.clientSecret?.message} />
                    <JVInput required column={2} label="Cat Secret Key" control={control} name="cat_ID" error={errors.clientSecret?.message} />
                    <JVCheckbox column={4} required label="Status" control={control} name="status" />
                    <div className="field col-12 md:col-3">
                        <label htmlFor="">&nbsp;</label>
                        <Button loading={loading} label="SUBMIT" type="submit"></Button>
                    </div>
                </form>
            </Dialog>
            <Dialog
                header={`Share "${selectedGroup?.clientTypeName}"`}
                visible={mosterPasswordsMapping.open}
                style={{ width: "60vw", height: "40vw" }}
                modal
                onHide={() => {
                    setMosterPasswordsMapping({ open: false, singleData: { id: 0 } });
                    setSelectedBranch([]);
                    setSelectedCompany(0);
                    setMappingList({ tableData: [], loading: false });
                }}
            >
                <div className="flex gap-3 mb-3">
                    <Dropdown value={selectedCompany} onChange={(e) => setSelectedCompany(e.value)} options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select a Company" className="w-full md:w-14rem" />
                    <MultiSelect
                        value={selectedBranch}
                        options={branches}
                        onChange={(e) => setSelectedBranch(e.value)}
                        optionLabel="branchName"
                        optionValue="branch_ID"
                        placeholder="Select Branch"
                        display="chip"
                        className="w-full"
                        style={{ maxHeight: "40px", overflow: "auto" }}
                    />

                    {/* <MultiSelect
                        value={selectedBranches}
                        options={branches}
                        onChange={(e) => setSelectedBranches(e.value)}
                        optionLabel="branchName"
                        optionValue="branch_ID"
                        placeholder="Select Branches"
                        display="chip"
                        className="w-full"
                        style={{ maxHeight: "40px", overflow: "auto" }}
                    /> */}
                    <div className="flex justify-content-end">
                        <Button label="Submit" icon="pi pi-plus" className="p-button-success" onClick={handleSubmit2} disabled={!selectedBranch || !selectedBranch.length} loading={mappingList.loading} />
                    </div>
                </div>

                <DataTable value={mappingList.tableData} size="small" showGridlines loading={mappingList.loading}>
                    <Column header="S.No" body={(_, opt) => opt.rowIndex + 1} />
                    <Column field="company_Name" header="Company" />
                    <Column field="branchName" header="Branch" />
                    <Column field="created_On" style={{ minWidth: "100px" }} header="Created On" body={(rowData: any) => safeFormatDate(rowData.created_On, "dd/MM/yyyy", DataFormat)} />
                    <Column header="Action" body={(rowData) => (
                        <Button icon="pi pi-trash" className="p-button-danger p-button-text" onClick={() => handleDelete(rowData)} />)}
                    />
                </DataTable>
            </Dialog>
            <Toast ref={toast} />
        </>
    );
}